import { css } from '@emotion/css';
import * as React from 'react';
import { Col, Row } from '../Grid';
import { CollapsibleList, List } from '../List';
import { Popover } from '../Popover';
const style = (mode) => css({
    '& > .popover-element': {
        display: mode === 'vertical' && 'block !important',
    },
});
export const Menu = (props) => {
    const { anchor, trigger, mode, children, position, elevation, backgroundColor, height, densed } = props;
    if (mode === 'expand') {
        return React.createElement(CollapsibleList, { header: anchor }, children);
    }
    if (mode === 'vertical') {
        return (React.createElement(List, { backgroundColor: backgroundColor, style: { width: 'auto' }, elevation: elevation, densed: densed, className: style(mode) }, children));
    }
    if (mode === 'horizontal') {
        return (React.createElement(Row, { gutter: [0, 0] }, children.map((e, i) => (React.createElement(Col, { flex: "1 0 auto", key: i }, e)))));
    }
    return (React.createElement(Popover, { cover: !position, hideArrow: true, content: React.createElement(List, { densed: densed, style: { maxHeight: height, overflow: 'auto' }, elevation: elevation }, children), position: position, trigger: trigger }, anchor));
};
Menu.displayName = 'Menu';
Menu.defaultProps = {
    mode: 'inline',
    trigger: 'onClick',
    height: '500px',
};
//# sourceMappingURL=Menu.js.map